module.exports = __webpack_public_path__ + "media/public/images/slider/banner_mobile-2471726f503e22a01dc8ae2eec9bd691.png";